import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';

import { MenuComponent } from './menu.component';
import { MenuItemComponent } from './menu-item.component';
import { MenuSectionComponent } from './menu-section.component';
import { DsCoreModule } from '../dsCore/core.module';

@NgModule({
    declarations: [
        MenuComponent,
        MenuItemComponent,
        MenuSectionComponent
    ],
    imports: [
        CommonModule,
        MatExpansionModule,
        MatListModule,
        MatIconModule,
        DsCoreModule
    ],
    exports: [
        MenuComponent
    ]
})
export class MenuModule { }
